import { render, staticRenderFns } from "./Contacts_sp2.vue?vue&type=template&id=24bb207d&scoped=true&"
import script from "./Contacts_sp2.vue?vue&type=script&lang=ts&"
export * from "./Contacts_sp2.vue?vue&type=script&lang=ts&"
import style0 from "./Contacts_sp2.vue?vue&type=style&index=0&id=24bb207d&lang=scss&scoped=true&"
import style1 from "./Contacts_sp2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bb207d",
  null
  
)

export default component.exports